var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H513V342H0V0Z",
    fill: "#009B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 19.2998L461.4 170.7L256.5 322L50.6 170.7L256.5 19.2998Z",
    fill: "#FEDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 251.4C300.904 251.4 336.9 215.404 336.9 171C336.9 126.596 300.904 90.6001 256.5 90.6001C212.096 90.6001 176.1 126.596 176.1 171C176.1 215.404 212.096 251.4 256.5 251.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9 165.7C202 165.7 188.5 167.8 175.8 171.7C176.4 215.6 212.1 251 256.1 251C283.3 251 307.4 237.4 321.9 216.7C297 185.7 258.7 165.7 215.9 165.7ZM334.9 186C335.8 181 336.4 175.9 336.4 170.6C336.4 126.2 300.4 90.2002 256 90.2002C222.9 90.2002 194.5 110.3 182.1 138.8C193 136.6 204.2 135.4 215.7 135.4C262.5 135.5 304.7 154.9 334.9 186Z",
    fill: "#002776"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrFlag);
export default __webpack_public_path__ + "static/media/br-flag.0276fa649135d26c42f6c779335f83a5.svg";
export { ForwardRef as ReactComponent };